import { useMutation } from '@tanstack/react-query';
import axiosClient from 'api/config/axios';
import { adaptTradeEscrow } from 'api/escrow/adapters';

type Params = {
  tradeId: number;
};

/**
 * Calls the escrow complete-payment endpoint and returns the adapted escrow.
 *
 * Error handling is intentionally omitted at the mutation level so the caller
 * (Actions.tsx) can show context-specific messages for 422 and 409 responses
 * without double-firing snackbars.
 */
async function completeEscrowPayment(params: Params) {
  const result = await axiosClient.mutate.post(`/api/v1/escrow/trades/by-trade/${params.tradeId}/complete-payment`);
  return adaptTradeEscrow(result.data.escrow);
}

const mutationKey = ['escrow', 'complete-payment'] as const;

export function useCompleteEscrowPaymentMutation() {
  return useMutation({
    mutationKey,
    mutationFn: completeEscrowPayment,
  });
}
